import React, { useEffect, createElement } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './components/Button';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { TestimonialsSection1, TestimonialsSection2 } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductShowcase } from './components/ProductShowcase';
import { Bonuses } from './components/Bonuses';
import { PurchaseSection } from './components/PurchaseSection';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { StickyMobileCTA } from './components/StickyMobileCTA';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    !function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '943022892065433');
    window.fbq('track', 'PageView');
  }, []);
  const closingChecklist = ['6 Tomos — 360 páginas de material teórico-práctico', 'Bono 01: Slide Master — 60 presentaciones listas para proyectar', 'Bono 02: Banco de Actividades Anti-IA', 'Bono 03: Video-Club Filosófico — 30 películas y series analizadas', 'Bono 04: Guía de Dinámicas de Debate — 20 técnicas probadas', 'Actualizaciones de por vida', 'Edición 2026 — Español Neutro — 100% Editable', 'Entrega inmediata en menos de 5 minutos', 'Garantía de devolución total — 7 días sin preguntas'];
  const cadaSemanaSinElKit = ['Noches buscando textos que no terminan de funcionar', 'Actividades armadas de apuro que no generan lo que esperabas', 'Evaluaciones construidas bajo presión sin criterio claro', 'Alumnos que entregan tareas hechas con ChatGPT porque no tuvieron una mejor propuesta', 'Energía gastada en planificación que podría ir a tus estudiantes'];
  return <div className="min-h-screen bg-brand-dark font-sans pb-16 md:pb-0 text-brand-text" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProofBar data-id="element-2" />
      <TestimonialsSection1 data-id="element-3" />
      <PainPoints data-id="element-4" />
      <ProductShowcase data-id="element-5" />
      <Bonuses data-id="element-6" />
      <PurchaseSection id="compra" data-id="element-7" />
      <TestimonialsSection2 data-id="element-8" />

      <Guarantee data-id="element-9" />
      <FAQ data-id="element-10" />

      {/* Closing CTA Section */}
      <section className="py-8 md:py-12 px-4 bg-brand-dark text-center border-t border-black/5" data-id="element-11">
        <div className="max-w-3xl mx-auto" data-id="element-12">
          <h2 className="text-xl md:text-2xl font-serif font-bold text-brand-text mb-3 leading-tight" data-id="element-13">
            El próximo lunes podés seguir improvisando con textos que nadie
            entiende...
          </h2>
          <p className="text-lg md:text-xl font-bold text-brand-accent mb-6" data-id="element-14">
            O podés tener todo resuelto desde hoy.
          </p>

          {/* Cada semana sin el Kit */}
          <div className="bg-brand-card border border-black/10 rounded p-5 text-left mb-8 max-w-2xl mx-auto" data-id="element-15">
            <p className="text-sm md:text-base font-bold text-brand-text mb-4" data-id="element-16">
              Cada semana sin el Kit es otra semana de:
            </p>
            <div className="space-y-3" data-id="element-17">
              {cadaSemanaSinElKit.map((point, i) => <div key={i} className="flex items-start" data-id="element-18">
                  <span className="text-brand-danger mr-2 shrink-0 font-bold" data-id="element-19">
                    ▸
                  </span>
                  <p className="text-sm text-brand-text leading-relaxed" data-id="element-20">
                    {point}
                  </p>
                </div>)}
            </div>
          </div>

          {/* Final Checklist */}
          <div className="bg-brand-card border border-black/10 rounded p-5 md:p-6 text-left mb-8 max-w-2xl mx-auto" data-id="element-21">
            <div className="space-y-3" data-id="element-22">
              {closingChecklist.map((item, i) => <div key={i} className="flex items-start" data-id="element-23">
                  <CheckCircle2 className="w-4 h-4 text-brand-success mr-3 shrink-0 mt-0.5" data-id="element-24" />
                  <span className="text-sm text-brand-text leading-relaxed" data-id="element-25">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>

          <p className="text-base md:text-lg text-brand-text font-serif italic leading-relaxed max-w-2xl mx-auto" data-id="element-26">
            "El mejor momento para tener este material era al inicio del año. El
            segundo mejor momento es hoy."
          </p>
        </div>
      </section>

      {/* Bottom Offer Section (no urgency) */}
      <section className="py-8 md:py-12 px-4 bg-brand-dark border-t border-black/5" data-id="element-27">
        <div className="max-w-xl mx-auto" data-id="element-28">
          <div className="bg-brand-card rounded border border-black/10 p-6 md:p-8 text-center shadow-sm" data-id="element-29">
            <p className="text-sm font-bold text-brand-accent mb-2" data-id="element-30">
              🏆 OFERTA ÚNICA
            </p>
            <h3 className="text-xl md:text-2xl font-serif font-bold text-brand-text mb-4" data-id="element-31">
              KIT COMPLETO FILOSOFÍA LISTA
            </h3>
            <p className="text-sm md:text-base text-brand-text mb-6" data-id="element-32">
              Los 6 tomos + 4 bonos estratégicos + Actualizaciones de por vida
            </p>

            <div className="mb-6" data-id="element-33">
              <span className="text-base text-brand-text/50 line-through mr-2" data-id="element-34">
                USD 45.00
              </span>
              <span className="text-3xl md:text-4xl font-bold text-brand-gold" data-id="element-35">
                Hoy: USD 19,90
              </span>
            </div>

            <Button href="https://filosofia.impultienda.ar/checkout" className="w-full mb-4" data-id="element-36">
              📜 → QUIERO EL KIT COMPLETO
            </Button>

            <p className="text-xs text-brand-text/70 mb-4 leading-relaxed" data-id="element-37">
              El precio está en dólares estadounidenses (USD). El cobro se
              realiza automáticamente en la moneda de tu país al tipo de cambio
              del momento.
            </p>

            <div className="text-xs font-bold text-brand-text/80 flex flex-wrap justify-center gap-x-4 gap-y-2" data-id="element-38">
              <span data-id="element-39">🔒 Pago seguro</span>
              <span data-id="element-40">⚡ Acceso en 5 min</span>
              <span data-id="element-41">🛡️ Garantía 7 días</span>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-42" />
      <SocialProofPopup data-id="element-43" />
      <StickyMobileCTA data-id="element-44" />

      <noscript data-id="element-45">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=943022892065433&ev=PageView&noscript=1" alt="" data-id="element-46" />
      </noscript>
    </div>;
}